var Reverb = window.Reverb || {};
Reverb.Listing = Reverb.Listing || {};

Reverb.Listing.CapsDetector = (function () {
  function tooManyCaps(string) {
    var length = string.length,
      caps = string.match(/[A-Z]/g),
      capsCount = caps && caps.length || 0,
      capsRatio = capsCount / length,               // used to detect more than 50% caps
      lotsOfCapsInARow = string.match(/[A-Z\s]{10,}/); // at least 10 caps in a row


    return (length > 5 && lotsOfCapsInARow && (capsCount >= 10 || capsRatio >= 0.5));
  }

  function tooManyBadChars(string) {
    return string.match(/[*+!]{2,}/);
  }

  function triggerMessage(inputSelector, messageSelector) {
    var tooManyCapsUsed = tooManyCaps($(inputSelector).val()),
      badPunctuation = tooManyBadChars($(inputSelector).val()),
      message = $(messageSelector);

    if (tooManyCapsUsed || badPunctuation) {
      if (tooManyCapsUsed) {
        message.text(message.data('too-many-caps'));
      } else if (badPunctuation) {
        message.text(message.data('punctuation-warning'));
      }

      message.fadeIn();
    } else {
      message.hide();
    }
  }

  function init(inputSelector, messageSelector) {
    $(inputSelector).on('keyup', function () {
      triggerMessage(inputSelector, messageSelector);
    });
  }

  return {
    init: init
  };
})();


$(() => {
  Reverb.Listing.CapsDetector.init('[data-bind=\'detect-caps\']', '[data-bind=\'caps-warning\']');
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy/listing/caps_detector.js